import React, { useState, useEffect } from "react";
import WorkFlow from "@/components/workflow";
import { Spin,  } from 'antd';
import useHTTP from "@/hooks/useHTTP.mjs";
import runAsync from "@/script/runAsync.mjs";
import Header from "./FlowMenu";
import FlowImagePreview from "./FlowImage";
import { useNavigate } from "react-router-dom";
import useDocTitle from '@/hooks/useDocTitle.mjs'
import parseMap from '@/components/SoftwareMap/scripts/parseMap.mjs';

function processArray(arr) {
  let firstWFKey = null;

  function traverse(obj) {
      if (Array.isArray(obj)) {
          for (let item of obj) {
              traverse(item);
          }
      } else if (typeof obj === 'object' && obj !== null) {
          if ((obj.type === 'WF' && obj.demoType == 'IMG' && !obj.image)
            || (obj.type !== 'WF' && (!obj.children || obj.children.length == 0))
          ) {
              obj.disabled = true;
          } else if (obj.type === 'WF' && firstWFKey == null) {
              firstWFKey = obj;
          }

          for (let key in obj) {
              if (obj.hasOwnProperty(key)) {
                  traverse(obj[key]);
              }
          }
      }
  }

  traverse(arr);

  return firstWFKey;
}



const Load = <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Spin /></div>;
const FlowPreview = () => {
  const params = new URLSearchParams(location.search.split("?")[1]);
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [uvObj, setUvObj] = useState({});
  const [current, setCurrent] = useState({id: undefined, name: ''});
  const [menuData, setMenuData] = useState([]);
  const [currentType, setCurrentType] = useState(null)
  const [wfImages, setWfImages] = useState([]);
    useDocTitle('流程看板');

  const http = useHTTP();
  
  // 组件初始化
  useEffect(() => {
    const wfId = params.get("wfId");
    const images = params.get('images')?.split(',') ?? [];
    const prjId = params.get("prjId");
    const sVer = params.get("sVer") || 1;
    if(images.length) {
      setWfImages(images)
    }
    if(!wfId && !prjId) return;
    if(prjId) {
      handleFetchMenu({ prjId, sVer }, true)
      return;
    }
    if(wfId) {
      handleFetchData(wfId, true)
    }
  }, []);

  // 将handleFetchData改造为Promise
  const handleFetchData = async (wfId, isFirst = false) => {
    setLoading(true);
    try {
      const param = { pkid: wfId }
      let url = '/oneBmBfWf';
      if(params.get('prjPatternId')) {
        param.prjPatternId = params.get('prjPatternId');
        url = '/pattern/oneBmBfWf';
      }
      const data = await runAsync(
        async () => {
          return await http.get(url, param);
        },
        {
          error: { content: (err) => `查询失败: ${err.message}` },
          loading: { show: false },
          success: { show: false },
        }
      );
      if(data.demoType == "DEMO") {
        setData({ pkid: wfId, prjId: data.prjId, sVer: data.sVer, wfMap: data.wfMap, bfId: data.bfId, bfCode: data.bfCode, bfTypeCode: data?.bfTypeCode || 'TARGET' });
      } else {
        const fileIdData = data?.demoMap && JSON.parse(data?.demoMap)
          ? parseMap(data?.demoMap)[0]
          : undefined;
        const fileId = fileIdData?.data?.fileId;
        setData({ pkid: wfId, prjId: data.prjId, sVer: data.sVer, wfMap: data.wfMap, bfId: data.bfId, bfCode: data.bfCode, fileId })
      }
      setCurrentType(data.demoType)
      setLoading(false)
      setCurrent({id: wfId, name: data.wfName, bfName: data.bfName, bfId: data.bfId})
      if(isFirst) handleFetchMenu({  prjId: data.prjId, sVer: data.sVer });
    } catch (err) {
      console.log(err);
    }
  };

  const handleFetchMenu = async (searchObj, isFirst=false) => {
    if (!searchObj.prjId) return;
    const param = {
      prjId: searchObj.prjId,
      sVer: searchObj.sVer
    }
    let url = '/pa/loadWftree';
    if(params.get('prjPatternId')) {
      param.prjPatternId = params.get('prjPatternId');
      url = '/pattern/pa/loadWftree';
    }
    const data = await runAsync(
        async () => {
            return await http.get(url, param)
        },
        {
            error: {content: (err) => `查询菜单失败: ${err.message}`},
            loading: {show: false},
            success: {show: false},
        }
    );
    if (data && data.length > 0) {
      const firstWFKey = processArray(data)
      setMenuData(data);
      if (isFirst) {
        handleMenuChange(firstWFKey.key, firstWFKey)
      }
    }
  };

  const handleMenuChange = (id, option) => {
      let urlParams = new URLSearchParams(location.search);
      if (option.demoType == 'IMG') {
        // const images = Array.isArray(option.image) ? option.image.slice(0,1) : [option.image] ;
        urlParams.set('wfId', id);
        // urlParams.set('images', images.join(','));
        handleFetchData(id)
        // setWfImages(images)
        // if(option.demoType != currentType) {
        //   setCurrentType(option.demoType)
        // }
      } else {
        urlParams.delete('images')
        urlParams.set('wfId', id);
        handleFetchData(id)
      }

      navigate({
        pathName: '/FlowPreview',
        search: urlParams.toString()
      });
    }

  
  return (
    <div className="flex flex-col h-full w-full">
      <div style={{ height: "60px" }}>
        <Header current={current} menuData={menuData} handleMenuChange={handleMenuChange} />
      </div>
      <div className="tailwind-container w-full" style={{ height: "calc(100vh - 60px)" }}>
        {!loading ? <>
          {
            currentType == 'DEMO' && <WorkFlow preview {...data} /> 
          }
          {
            currentType == 'IMG' && <FlowImagePreview prjData={data} data={data} />
          }
        </> : Load}
      </div>
    </div>
  );
};

export default FlowPreview;
